import { render } from "./history.vue?vue&type=template&id=24ce64e8&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"

import "./history.vue?vue&type=style&index=0&id=24ce64e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EZELINK\\Wajiha\\Projects\\EzenmsV2_vueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ce64e8"]])

export default __exports__